import React from 'react';

import styles from './index.module.css';
import { Typography } from 'antd';

function WhyAA() {
  return (
    <div className={styles.why_aa_container}>
      <div className={styles.why_aa_heading_container}>
        <Typography.Text className={styles.why_aa_heading}>
          We have partenered with RBI regulated Account Aggregator to securely
          share your accounts
        </Typography.Text>
      </div>

      <div className={styles.why_aa_baner}>
        <div className={styles.why_aa_question_div}>
          {' '}
          <Typography.Text className={styles.why_aa_question}>
            What are Account Aggregators?
          </Typography.Text>
          <Typography.Text className={styles.why_aa_answer}>
            RBI- Authorised institutions that securely find and share your
            account information with us
          </Typography.Text>
        </div>
      </div>

      <Typography.Text className={styles.feature_heading}>
        Features
      </Typography.Text>

      <div className={styles.feature_div_container}>
        <div className={styles.feature_row}>
          <div className={styles.feature_div}>
            <Typography.Text className={styles.feature_text}>
              AA is RBI-authorised institution
            </Typography.Text>
          </div>
          <div className={styles.feature_div}>
            {' '}
            <Typography.Text className={styles.feature_text}>
              AA can not read or store any of your data
            </Typography.Text>
          </div>
        </div>
        <div className={styles.feature_row}>
          <div className={styles.feature_div}>
            {' '}
            <Typography.Text className={styles.feature_text}>
              AA can help share your selected accounts
            </Typography.Text>
          </div>
          <div className={styles.feature_div}>
            {' '}
            <Typography.Text className={styles.feature_text}>
              You can revoke consent anytime using AA app
            </Typography.Text>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyAA;
